// import Loader from "../components/common/Loader";
import { saveAs } from 'file-saver';
import moment from 'moment';

export const moveToAnotherColumn = (
  tickets,
  startColumn,
  startColumnTicketIndex,
  finishColumn,
  finishColumnTicketIndex
) => {
  const startTickets = [...tickets[startColumn]];
  startTickets.splice(startColumnTicketIndex, 1);

  const finishTickets = [...tickets[finishColumn]];
  finishTickets.splice(
    finishColumnTicketIndex,
    0,
    tickets[startColumn][startColumnTicketIndex]
  );

  return {
    ...tickets,
    [startColumn]: startTickets,
    [finishColumn]: finishTickets,
  };
};

export const commify = (num) =>
  num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "";

export const shortify = (num) => {
  if (num >= 1000000000) {
    return `${(num / 1000000000).toFixed(1).replace(/\.0$/, "")}G`;
  }
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1).replace(/\.0$/, "")}M`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1).replace(/\.0$/, "")}K`;
  }

  return num;
};

export const convertDateToUTC = (date) => {
  const convertToTwoDigits = (num) => {
    if (num.toString().length === 1) return `0${num}`
    else return num.toString()
  }
  return `${Number(date.getFullYear())}-${convertToTwoDigits(Number(date.getMonth()) + 1)}-${convertToTwoDigits(Number(date.getDate()))}T00:00:00.000Z`;
  // return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + 1, 1, date.getUTCMinutes(), date.getUTCSeconds());
}

export const numberWithCommas = (x) =>
  x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;

export const toDecimalPoint = (num, point = 1) =>
  parseFloat(num?.toFixed(point)) || 0

export const customRound = (number, fractionNumber = 0.5) => {
  const fraction = number - Math.floor(number);

  if (fraction >= fractionNumber) {
    // Round up
    return Math.ceil(number);
  } else {
    // Round down
    return Math.floor(number);
  }
}

export const nFormatter = (num, digits) => {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });
  return item
    ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
    : "0";
};

export const toAbsoluteUrl = (pathname) =>
  (process.env.REACT_APP_ENDPOINT || "") + pathname;

export const getData = (obj) => {
  let data = {};
  obj && obj.map((i) => (data[i.id] = i.value));
  return data;
};

// dd/mm/yyyy hh:mm:ss to a Date object
export const convertDateTimeStringToDate = (date) => {
  if (!date) return;
  const [dateComponents, timeComponents] = date.split(" ");
  const [day, month, year] = dateComponents.split("/");
  const [hours, minutes, seconds] = timeComponents.split(":");
  return new Date(+year, month - 1, +day, +hours, +minutes, +seconds);
};

export const DATEFORMATREGEX =
  /^([1-9]|([012][0-9])|(3[01])).([0]{0,1}[1-9]|1[012]).\d\d\d\d [012]{0,1}[0-9]:[0-6][0-9]:[0-6][0-9]$/;

export const descendingComparator = (a, b, orderBy) => {
  if (DATEFORMATREGEX.test(a[orderBy]) && DATEFORMATREGEX.test(b[orderBy])) {
    return (
      new Date(convertDateTimeStringToDate(b[orderBy])).getTime() -
      new Date(convertDateTimeStringToDate(a[orderBy])).getTime()
    );
  }
  return b[orderBy] < a[orderBy] ? -1 : 1;
};

export const getComparator = (order, orderBy) => {
  return order === "DESC"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

const tableFilter = (arr, filters, searchValue) => {
  return arr
    .filter((item) =>
      Object.values(item).some((el) =>
        searchValue
          .split(" ")
          .some(
            (value, i) =>
              (value || i === 0) && el?.toString().toLowerCase().includes(value)
          )
      )
    )
    .filter((el) =>
      Object.keys(filters).every((item) =>
        el[item]?.toString().toLowerCase().includes(filters[item].toLowerCase())
      )
    );
};

export const stableSort = (array = [], comparator, filters, searchValue) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return tableFilter(
    stabilizedThis.map((el) => el[0]),
    filters,
    searchValue
  );
};

export const getDefaultSkeleton = () => {
  return (
    // <Loader height={700} width='100%'>
    //   <rect x='0' y='0' rx='4' ry='4' width='30%' height='50px' />
    //   <rect x='50%' y='0' rx='4' ry='4' width='30%' height='50px' />
    //   <rect x='82%' y='0' rx='4' ry='4' width='18%' height='50px' />
    //   {[...new Array(20)].map((val, i) => {
    //     return (
    //       <rect
    //         key={i}
    //         x='0'
    //         y={(i + 1) * 55}
    //         rx='4'
    //         ry='4'
    //         width='100%'
    //         height='50px'
    //       />
    //     );
    //   })}
    // </Loader>
    <p>Loading</p>
  );
};

export const getISOString = (date) => {
  const tzOffset = date.getTimezoneOffset() * 60000; //offset in milliseconds
  return (new Date(date.getTime() - tzOffset)).toISOString().slice(0, -1);
}

export const camelize = (str) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
}

export const renameKeysAndChangeValuesToString = (obj, newKeys, noValue) => {
  const entries = Object.keys(obj).map(key => {
    const newKey = newKeys[key] || key;

    if (noValue) return {[newKey]: obj[key].toString()};
    else return { [newKey]: newKey === 'incidentId' ? "" : obj[key].toString() };
  });

  return Object.assign({}, ...entries);
}

export const parsePolygonPaths = (svalue) => {
  const result = [];
  const r = /\(([^)]+)\)/g;
  svalue = svalue.slice(9, -1);
  let matches;
  while (matches = r.exec(svalue)) {
    const vals = matches[1].split(',');
    const coords = vals.map(function(val){
      const ll = val.trim().replace(/\(/gi, '').split(' ');
      return new window.google.maps.LatLng(ll[1], ll[0]);
    });
    result.push(coords);
  }
  return result;
}

// Function to convert WKT MULTIPOINT to Google Maps path
export const convertWKTMultiPointToGoogleMapsPath = (wktMultiPoint) => {
  // Extracting coordinates from WKT string
  // const coordinatesRegex = /\(([^)]+)\)/g;
  // const matches = wktMultiPoint.match(coordinatesRegex);

  // if (!matches) {
  //   throw new Error("Invalid WKT MULTIPOINT format");
  // }

  // // Mapping extracted coordinates to Google Maps path format
  // const googleMapsPath = matches.map((match) => {
  //   const [longitude, latitude] = match
  //     .replace(/[()]/g, "")
  //     .split(" ")
  //     .map(Number);
  //   // return { lat: latitude, lng: longitude };
  //   return new window.google.maps.LatLng(latitude, longitude);
  // });

  // return googleMapsPath;
  // Extracting coordinates from WKT MultiPoint
  let coordinates = wktMultiPoint.match(/[\d.]+ [\d.]+/g);

  // Creating an array to store LatLng objects
  let LatLngArray = [];

  // Converting coordinates to LatLng objects
  coordinates.forEach(function(coord) {
    let latlng = coord.split(' ').map(function(val) {
      return parseFloat(val);
    });
    LatLngArray.push(new window.google.maps.LatLng(latlng[1], latlng[0]));
  });
  return LatLngArray;
}

export const verticalTooltipLinePlugin = {
  afterDraw: chart => {
    if (chart.tooltip?._active?.length) {
      let x = chart.tooltip._active[0].element.x;
      let yAxis = chart.scales.y;
      let ctx = chart.ctx;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, yAxis.top);
      ctx.lineTo(x, yAxis.bottom);
      ctx.lineWidth = 1;
      ctx.strokeStyle = '#030303';
      ctx.setLineDash([5, 5]);
      ctx.stroke();
      ctx.restore();
    }
  }
}

export const getRequiredTicketFields = data => {
  return (({Id, Status, Description, IssueType, IssueDescription, Priority, DueDate, Tasks, AssignedTo, Media, RequesterName, RequesterEmail, RequesterPhone, RequestDate, IsExecutable, NotExecutableReason }) => ({Id, Status, Description, IssueType, IssueDescription, Priority, DueDate, Tasks, AssignedTo, Media, RequesterName, RequesterEmail, RequesterPhone, RequestDate, IsExecutable, NotExecutableReason}))(data)
}

export const getHumanDate = (date) => {
  return date && new Date(date).toLocaleString('en-US', {day: 'numeric', month: 'short', year: 'numeric'})
}

export const getDifferencesBetweenTwoDate = (date1, date2) => {
  date1 = new Date(date1);
  date2 = date2 ? new Date(date2) : new Date();
  const diffTime = Math.abs(date2 - date1);
  return Math.floor(diffTime / (1000 * 60 * 60 * 24));
}

export const saveFile = (res) => {
  const dirtyFileName = res.headers["content-disposition"];
  const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
  const fileName = dirtyFileName.match(regex)[3];
  const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
  saveAs(blob, fileName);
}

export const getDayMinutesAgo = (date) => {
  const currentDate = moment();

  const specificDate = moment(date);
  const minutesAgo = currentDate.diff(specificDate, 'minutes');
  const daysAgo = currentDate.diff(specificDate, 'days');
  if (daysAgo === 0) {
    return `${minutesAgo} minutes ago`;
  } else return `${daysAgo} days ago`;
}

export const Environment = process.env.NODE_ENV;
// export const GoogleMapApiKey = Environment === 'development' ? 'AIzaSyA8muk_JkK5lt-04XqfgeSUxf3YRzJAg64' : "AIzaSyCscN2ly2eaD8BhkMIOViLXiOuvmBY69Cw";
export const GoogleMapApiKey = 'AIzaSyCscN2ly2eaD8BhkMIOViLXiOuvmBY69Cw';
